import { FullscreenModal } from "shared";
import { InfoBanner } from "../index";

interface BannerModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

const BannerModal: React.FC<BannerModalProps> = ({
  isOpen,
  onClose,
  onSuccess,
}) => {
  return (
    <FullscreenModal
      className="info-banner__modal-wrapper"
      isOpen={isOpen}
      onClose={onClose}
    >
      <InfoBanner className="info-banner__modal" />
    </FullscreenModal>
  );
};

export default BannerModal;
